import React from 'react';
import { useLocation } from 'react-router-dom';

import { Loader } from "../";
import {withParamsFrame} from "../../HOCs";
import {IframePage} from "../../types/iframe";

const Billing: React.FC<IframePage> = ({ params }) => {
    const location = useLocation();
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        setLoaded(false);
    }, [location.pathname]);

    const basePath = process.env.REACT_APP_BASE_PATH || '/a';
    const billingPath = location.pathname.replace(basePath, '');

    return (
        <>
            <div className="sm:pt-8 sm:pl-8">
                <iframe
                    key={location.pathname}
                    className={`${!loaded ? 'min-h-[auto]' : 'page-iframe-min'}`}
                    src={`https://lk.market${billingPath}${params}`}
                    title="Billing"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}
                    onLoad={() => setLoaded(true)}
                />
            </div>
            {!loaded && <Loader />}
        </>
    );
};

export default withParamsFrame(Billing);
